import React, { useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CircularProgress from '@mui/material/CircularProgress';
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
import InputField from "../styles/InputField";
import validator from "validator";
import { Link } from "react-router-dom";
import Modal from "../styles/Modal";


const ResetPasswordPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false); // State to control modal visibility

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
    setApiError("");
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (validator.isEmpty(formData.password)) {
      newErrors.password = "Password is required";
      isValid = false;
    } else if (!validator.isLength(formData.password, { min: 6 })) {
      newErrors.password = "Password must be at least 6 characters long";
      isValid = false;
    } else if (!validator.matches(formData.password, /[0-9]/)) {
      newErrors.password = "Password must contain at least one number";
      isValid = false;
    } else if (!validator.matches(formData.password, /[!@#$%^&*]/)) {
      newErrors.password = "Password must contain at least one special character";
      isValid = false;
    }

    if (validator.isEmpty(formData.confirmPassword)) {
      newErrors.confirmPassword = "Confirm Password is required";
      isValid = false;
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      setLoading(true);
      const data = {
        token: token,
        newPassword: formData.password,
      };


      const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/auth/reset-password`, data);

      if (response.data) {
        setLoading(false);
        setModalOpen(true);
    }
    } catch (error) {
      setLoading(false);
      setApiError(error.response?.data?.error || "An error occurred");
    }
  };

  const handleModalClose = () => {
    setModalOpen(false); // Close the modal
    navigate(`/login`); // Navigate to the login page
  };
  return (
    <div className="flex flex-col md:flex-row h-screen">
      {/* Background blur effect */}
      {loading && <div className="absolute inset-0 backdrop-filter backdrop-blur-sm z-10"></div>}

      {/* Left Section */}
      <div className="w-full md:w-1/2 p-4 h-full">
        <Link to='/'><ArrowBackIcon className="cursor-pointer absolute top-8 left-8 text-black" /></Link>
        <img
         src={`${process.env.PUBLIC_URL}/images/log1.jpg`}
          alt="login"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Right Section */}
      <div className="bg-register_page_bg w-full md:w-1/2 p-4 flex items-center justify-center h-full">
        <div className="bg-register_page_bg p-8 text-center md:w-4/5 mx-auto">
          <h2 className="text-3xl font-bold mb-4 text-white">Reset Password</h2>
          <p className="text-base text-white mb-6">
            Enter password to reset
          </p>

          <form className="grid grid-cols-1 gap-6 mt-20" onSubmit={handleResetPassword}>
            {/* Password */}
            <div>
              <InputField
                label="Password"
                type="password"
                id="password"
                name="password"
                value={formData.password}
                autoComplete="off"
                onChange={handleInputChange}
                focusColor="white"
                top="6"
              />
              {errors.password && (
                <p className="text-red-800 font-bold text-xs text-left">
                  {errors.password}
                </p>
              )}
            </div>
            {/* Confirm Password */}
            <div>
              <InputField
                label="Confirm Password"
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                value={formData.confirmPassword}
                autoComplete="off"
                onChange={handleInputChange}
                focusColor="white"
                top="6"
              />
              {errors.confirmPassword && (
                <p className="text-red-800 font-bold text-xs text-left">
                  {errors.confirmPassword}
                </p>
              )}
            </div>
            {apiError && (
              <p className="text-red-800 font-bold text-xs text-left w-full">
                {apiError}
              </p>
            )}

            {/* Submit Button */}
            <div className="mb-4">
              <button className="flex justify-center text-blue-600 bg-white p-1 rounded cursor-pointer w-full mt-4 active:text-sec-color active:bg-white">
                <LoginOutlinedIcon className="mr-2" />
                <p className="text-lg font-bold">Reset Password</p>
              </button>
            </div>
          </form>
        </div>
      </div>
      {modalOpen && (
        <Modal
          title="Password Reset Successful"
          message="Your password has been reset successfully"
          onClose={handleModalClose}
        />
      )}
      {/* Circular progress */}
      {loading && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20">
          <CircularProgress style={{ color: 'blue' }} />
        </div>
      )}
    </div>
  );
};

export default ResetPasswordPage;
